import React from 'react'
import { Header } from 'components/Header'
import { Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { usePositionsContextValue } from '../context/PositionsProvider'

export const PositionsHeader = () => {
  const { state, actions } = usePositionsContextValue()

  return (
    <Header
      title="Positions"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        </Flex>
      }
    />
  )
}
